import { render, staticRenderFns } from "./AddReseller.vue?vue&type=template&id=07077c0e&scoped=true&"
import script from "./AddReseller.vue?vue&type=script&lang=js&"
export * from "./AddReseller.vue?vue&type=script&lang=js&"
import style0 from "./AddReseller.vue?vue&type=style&index=0&id=07077c0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07077c0e",
  null
  
)

export default component.exports